const env = import.meta.env;
const runtimeConfig = window.VIBECO_FRONTEND_CONFIG ?? {};

function cleanUrl(value?: string) {
  return typeof value === 'string' ? value.trim().replace(/\/$/, '') : '';
}

function readBoolean(value: unknown, fallback: boolean) {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return fallback;
}

export const appConfig = {
  apiBaseUrl: cleanUrl(env.VITE_FC_API_BASE || (env.DEV ? '/api' : runtimeConfig.apiBaseUrl)),
  cdnBaseUrl: cleanUrl(runtimeConfig.cdnBaseUrl || env.VITE_CDN_BASE),
  downloadUrl: cleanUrl(runtimeConfig.downloadUrl || env.VITE_DOWNLOAD_URL),
  consoleUrl: cleanUrl(runtimeConfig.consoleUrl || env.VITE_CONSOLE_URL),
  enableMocks: readBoolean(runtimeConfig.enableMocks ?? env.VITE_ENABLE_MOCKS, true),
  releaseChannel: runtimeConfig.releaseChannel || env.VITE_RELEASE_CHANNEL || 'local',
};

export function apiUrl(path: string) {
  if (!appConfig.apiBaseUrl) return '';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${appConfig.apiBaseUrl}${normalizedPath}`;
}
